import { sanitizeDoubleQuotes } from "../utils";

export const ContentItemMapper = {
  dehydrate: (contentItem) => {
    const {
      _destroy,
      position,
      language,
      type,
      s3Image,
      s3ImageFileName,
      id,
      caption,
      embedUrl,
      humanizedItemType,
      description,
    } = contentItem;

    const data = {
      _destroy: typeof _destroy === "boolean" && _destroy,
      position: (typeof position === "number" && parseInt(position, 10)) || 9999999,
      language: (typeof language === "string" && language) || "",
      type: (typeof type === "string" && type) || humanizedItemType || null,
      caption:
        (typeof caption === "string" && sanitizeDoubleQuotes(caption, { action: "escape" })) || "",
      description:
        (typeof description === "string" &&
          sanitizeDoubleQuotes(description, { action: "escape" })) ||
        null,
    };

    if (id && typeof id === "string") {
      data.id = id;
    }

    if (s3Image && typeof s3Image === "string" && s3Image.length > 1) {
      data.s3Image = s3Image;
    }

    if (humanizedItemType === "embed") {
      if (embedUrl && typeof embedUrl === "string" && embedUrl.length > 1) {
        data.embedUrl =
          (typeof embedUrl === "string" && sanitizeDoubleQuotes(embedUrl, { action: "remove" })) ||
          "";
      } else {
        return false;
      }
    }

    if (type === "image") {
      if (s3ImageFileName && typeof s3ImageFileName === "string" && s3ImageFileName.length > 1) {
        data.s3ImageFileName = sanitizeDoubleQuotes(s3ImageFileName, { action: "remove" });
      }
    }

    return data;
  },
  hydrate: (contentItem) => {
    const {
      _destroy,
      position,
      language,
      s3Image,
      caption,
      id,
      contentId,
      humanizedItemType,
      description,
      descriptionHtml,
      url,
      embedUrl,
      embedHtml,
      embedTitle,
      embedType,
      embedAuthorName,
      embedProviderName,
      emebedThumbnailUrl,
      errors,
    } = contentItem;

    const data = {
      _destroy: _destroy || false,
      position: (typeof position === "number" && position > 0 && position) || 1, // use 1 by default
      language: (typeof language === "string" && language) || null,
      type: (typeof humanizedItemType === "string" && humanizedItemType) || null,
      caption: (typeof caption === "string" && caption) || "",
      id: (typeof id === "string" && id) || null,
      humanizedItemType: (typeof humanizedItemType === "string" && humanizedItemType) || null,
      s3ImageFileName: (typeof s3ImageFileName === "string" && s3ImageFileName) || "",
      description: (typeof description === "string" && description) || "",
      descriptionHtml: (typeof descriptionHtml === "string" && descriptionHtml) || "",
      embedUrl: (typeof embedUrl === "string" && embedUrl !== "null" && embedUrl) || "",
      embedHtml: (typeof embedHtml === "string" && embedHtml) || "",
      embedTitle: (typeof embedTitle === "string" && embedTitle) || "",
      embedType: (typeof embedType === "string" && embedType) || "",
      embedAuthorName: (typeof embedAuthorName === "string" && embedAuthorName) || "",
      embedProviderName: (typeof embedProviderName === "string" && embedProviderName) || "",
      emebedThumbnailUrl: (typeof emebedThumbnailUrl === "string" && emebedThumbnailUrl) || "",
      errors: (typeof errors === "object" && errors.map((error) => error)) || [],
    };

    // Hack: if the content item received from BE is an image but it comes without ID, we won't be showing it, but a s3image type content item
    if (!id && typeof humanizedItemType === "string" && humanizedItemType === "image") {
      data.humanizedItemType = "s3image";
      data.type = "s3image";
    }

    if (!id) {
      data.contentId = contentId || `${Math.floor(Math.random() * 10000 + 1)}`;
    }

    if (humanizedItemType === "image") {
      if (typeof url === "string" && typeof s3Image === "object" && s3Image.url[0]) {
        data.url = url;
      } else {
        return false;
      }
    }

    return data;
  },
};
